import { useState } from 'react';
import MusselHarvestModal from './MusselHarvestModal';
import OysterHarvestModal from './OysterHarvestModal';
import {
  ILineResource,
  IMusselLineResource,
  IOysterLineResource,
  ISeaweedLineResource,
} from '../../../entities/farms.entities';
import SeaweedHarvestModal from './SeaweedHarvestModal';
import WasteHarvestModal from '../WasteHarvestModal';
import { AreaClosedConfirmModal } from '../../CommonViews';

interface Props {
  visible: boolean;
  title?: string;
  lineData: ILineResource;
  data?: any;
  onCancel: () => void;
  onConfirm: (data: any) => void;
  overConfirm?: (data: any) => Promise<any>; // only for MUSSEL
  onlyView?: boolean; // only for MUSSEL
  warningMessage?: string; // only for MUSSEL
  lineChangeable?: boolean; // only for MUSSEL
  updateID?: number;
}

const HarvestCompleteModal = ({
  visible,
  title,
  lineData,
  data,
  onCancel,
  onConfirm,
  overConfirm,
  onlyView,
  warningMessage,
  lineChangeable,
  updateID,
}: Props) => {
  const [isConfirmed, setIsConfirmed] = useState(false);

  if (!onlyView && !isConfirmed) {
    return (
      <AreaClosedConfirmModal
        farmId={lineData.farm_id}
        onCancel={onCancel}
        onConfirm={() => setIsConfirmed(true)}
      />
    );
  }
  return (
    <>
      {!!data?.is_waste ? (
        <WasteHarvestModal
          visible={visible}
          lineData={lineData}
          data={data}
          onCancel={onCancel}
          onConfirm={onConfirm}
          overConfirm={overConfirm}
          onlyView={onlyView}
          warningMessage={warningMessage}
          lineChangeable={lineChangeable}
          updateID={updateID}
        />
      ) : lineData.crop_type === 'MUSSEL' ? (
        <MusselHarvestModal
          visible={visible}
          title={title}
          lineData={lineData as IMusselLineResource}
          data={data}
          onCancel={onCancel}
          onConfirm={onConfirm}
          overConfirm={overConfirm}
          onlyView={onlyView}
          warningMessage={warningMessage}
          lineChangeable={lineChangeable}
          updateID={updateID}
        />
      ) : lineData.crop_type === 'OYSTER' ? (
        <OysterHarvestModal
          visible={visible}
          title={title}
          lineData={lineData as IOysterLineResource}
          data={data}
          onCancel={onCancel}
          onConfirm={onConfirm}
          overConfirm={overConfirm}
          updateID={updateID}
          onlyView={onlyView}
        />
      ) : (
        <SeaweedHarvestModal
          visible={visible}
          title={title}
          lineData={lineData as ISeaweedLineResource}
          data={data}
          onCancel={onCancel}
          onConfirm={onConfirm}
          updateID={updateID}
          onlyView={onlyView}
        />
      )}
    </>
  );
};

export default HarvestCompleteModal;
